export default {
    imageAIFormRules: {
        enterDescription: 'Per favore inserisci la descrizione',
        invalidDescription: 'Per favore, inserisci una descrizione valida',
        enterNumberOfVariations: 'Scegli il numero di variazione, per favore',
        invalidNumberOfVariations: 'Puoi generare un massimo di 4 e un minimo di 1 variazione',
        enterStyle: 'Per favore, seleziona almeno uno stile',
    },
};
